module.exports = __webpack_public_path__ + "img/a-bottom.03da94f2.png";